import { render, staticRenderFns } from "./BankInformationUpdate.vue?vue&type=template&id=5f639b14&scoped=true"
import script from "./BankInformationUpdate.vue?vue&type=script&lang=js"
export * from "./BankInformationUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f639b14",
  null
  
)

export default component.exports